import React, { FC } from 'react';
import classNames from 'classnames';

import { Badge } from 'app/design-system/components/Badge';
import { ProgressBar } from 'app/design-system/components/ProgressBar';
import { useTranslation } from 'app/lang';

import { useLevelConfig } from './hooks/useLevelConfig';

import dictionary from './CashbackLevel.dictionary.json';

import styles from './CashbackLevel.module.scss';

export type CashbackLevelProps = {
  levelId: number;
  className?: string;
};

export const CashbackLevel: FC<CashbackLevelProps> = ({
  levelId,
  className,
}) => {
  const { t } = useTranslation();
  const rootClassNames = classNames(styles.root, className);
  const config = useLevelConfig(levelId);

  return (
    <div className={rootClassNames}>
      <div className={styles.rate}>
        <div className={styles.status}>
          <span className={styles.title}>
            {t(dictionary.percentRate, { percentRate: config.percentRate })}
          </span>
          <Badge {...config.badgeProps}
                 className={styles.badge}>
            {config.title}
          </Badge>
        </div>
        <span className={styles.description}>{config.description}</span>
      </div>
      <ProgressBar {...config.progressBarProps} />
    </div>
  );
};
